(ns frontend.ui.page.lp-report-editor.common.event
  (:require
   [common.schema.entities.lp-portal.lp-report-holding :as lp-report-holding]
   [frontend.controller.websocket.event :as ws]
   [frontend.ui.component.lp-portal.report.body.lifeline.fund.common :as lifeline-pdf]
   [frontend.ui.page.lp-portal.report.pdf.controller :as pdf-controller]
   [frontend.ui.page.lp-portal.report.pdf.view :as pdf-report]
   [frontend.ui.page.lp-report-editor.event :as editor-event]
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]
   [frontend.ui.page.lp-report-editor.common.sub :as common-sub]
   [frontend.utils :as fu]
   [potpuri.core :as p]
   [re-frame.core :as rf]))

(defn main-report->doc-def
  [db]
  (let [report (get-in db editor-sub/report-path)
        holdings (get-in db editor-sub/holdings-path)
        fund-report-ui-data @(rf/subscribe [::editor-sub/fund-report-ui-data (:db/id report)])
        {:keys [fund-name reporting-period reference-date]} fund-report-ui-data
        fund-pdf-pages (pdf-controller/fund-pages (:lp-report/template-type report)
                                                  fund-report-ui-data)
        last-pages (pdf-controller/last-pages (:lp-report/template-type report)
                                              fund-report-ui-data)
        template-type (:lp-report/template-type report)
        holding-pdf-pages
        (->> (:lp-report/holdings report)
             (map (fn [holding-id]
                    (get holdings holding-id)))
             (remove (fn [holding-report]
                       (let [holding-template (:lp-report-holding/template-type holding-report)]
                         (or (nil? holding-template)
                             (= :lp-report-holding-template/no-reporting holding-template)))))
             (sort lp-report-holding/compare-holdings)
             (mapcat (fn [holding-report]
                       (let [template-type (:lp-report-holding/template-type holding-report)
                             ui-data @(rf/subscribe [::editor-sub/holding-report-ui-data
                                                     (:db/id holding-report)])]
                         (pdf-controller/holding-pages template-type ui-data))))
             (doall))
        pdf-doc (pdf-report/report fund-report-ui-data
                                   (concat fund-pdf-pages holding-pdf-pages last-pages)
                                   fund-name
                                   reporting-period
                                   reference-date
                                   template-type)]
    ;(js/console.log "PDF : " fund-pdf-pages "\n" holding-pdf-pages)
    pdf-doc))

(defn main-report->lifeline-custom-doc-def
  [db]
  (let [report                (get-in db editor-sub/report-path)
        holdings              (get-in db editor-sub/holdings-path)
        fund-report-ui-data   @(rf/subscribe
                                [::editor-sub/fund-report-ui-data
                                 (:db/id report)])
        {:keys [fund-name reporting-period reference-date]}
        fund-report-ui-data
        template-type         (:lp-report/template-type report) 
        fund-pdf-pages        (pdf-controller/fund-pages
                               template-type
                               fund-report-ui-data)
        last-pages            (pdf-controller/last-pages
                               template-type
                               fund-report-ui-data) 
        holding-reports       (->> (:lp-report/holdings report)
                                   (map #(get holdings %))
                                   (remove (fn [holding-report]
                                             (let [t (:lp-report-holding/template-type
                                                      holding-report)]
                                               (or (nil? t)
                                                   (= :lp-report-holding-template/no-reporting
                                                      t)))))
                                   (sort lp-report-holding/compare-holdings)
                                   (doall))
        regular-holdings      (filter
                               (fn [hr]
                                 (= :lp-report-holding-template.lifeline/holding
                                    (:lp-report-holding/template-type hr)))
                               holding-reports)
        exited-holdings       (filter
                               (fn [hr]
                                 (= :lp-report-holding-template.lifeline/exited-holding
                                    (:lp-report-holding/template-type hr)))
                               holding-reports)
        holding->pages        (fn [hr]
                                (let [t       (:lp-report-holding/template-type hr)
                                      ui-data @(rf/subscribe
                                                [::editor-sub/holding-report-ui-data
                                                 (:db/id hr)])]
                                  (pdf-controller/holding-pages t ui-data)))
        regular-section-pages (when (seq regular-holdings)
                                (concat
                                 [(lifeline-pdf/lifeline-holdings-title-page "Current")]
                                 (mapcat holding->pages regular-holdings)))

        exited-section-pages  (when (seq exited-holdings)
                                (concat
                                 [(lifeline-pdf/lifeline-holdings-title-page "Exited")]
                                 (mapcat holding->pages exited-holdings))) 
        all-pages             (concat
                               fund-pdf-pages
                               regular-section-pages
                               exited-section-pages
                               last-pages)

        pdf-doc               (pdf-report/report
                               fund-report-ui-data
                               all-pages
                               fund-name
                               reporting-period
                               reference-date
                               template-type)]
    pdf-doc))


(defn feeder-report->doc-def
  [_db feeder-report]
  (let [fund-report-ui-data @(rf/subscribe [::editor-sub/fund-report-ui-data
                                            (:db/id feeder-report)])
        {:keys [fund-name reporting-period reference-date]} fund-report-ui-data
        fund-pdf-pages (pdf-controller/fund-pages (:lp-report/template-type feeder-report)
                                                  fund-report-ui-data)
        template-type (:lp-report/template-type feeder-report)
        pdf-doc (pdf-report/report fund-report-ui-data
                                   fund-pdf-pages
                                   fund-name
                                   reporting-period
                                   reference-date
                                   template-type)]
    pdf-doc))

(defn holding-report->doc-def
  [db holding-id]
  (let [report (get-in db editor-sub/report-path)
        holdings (get-in db editor-sub/holdings-path)
        holding-report (get holdings holding-id)
        ui-data @(rf/subscribe [::editor-sub/holding-report-ui-data holding-id])
        fund-report-ui-data @(rf/subscribe [::editor-sub/fund-report-ui-data (:db/id report)])
        {:keys [fund-name reporting-period reference-date]} fund-report-ui-data
        template-type (:lp-report-holding/template-type holding-report)
        holding-pages (pdf-controller/holding-pages template-type ui-data)]

    (pdf-report/report
     fund-report-ui-data
     holding-pages
     fund-name
     reporting-period
     reference-date
     (:lp-report/template-type report))))

(rf/reg-event-fx
 ::save-as-pdf
 (fn [{db :db} [_ selected-report feeder?]]
   (let [template-type (:lp-report/template-type selected-report)
         pdf-doc (cond feeder?
                       (feeder-report->doc-def db selected-report)
                       (or (= template-type :lp-report-template.lifeline/fund)
                           (= template-type :lp-report-template.lifeline/fund-v)
                           (= template-type :lp-report-template.lifeline/fund-vi))
                       (main-report->lifeline-custom-doc-def db)
                       :else
                       (main-report->doc-def db))
         fund-report-ui-data @(rf/subscribe [::editor-sub/fund-report-ui-data
                                             (:db/id selected-report)])
         {:keys [fund-name reporting-period]} fund-report-ui-data]
     (.call (aget pdf-doc "download")
            pdf-doc
            (str fund-name "_" reporting-period ".pdf")))))


(rf/reg-event-fx
 ::burn-completed
 (fn [{db :db} _]
   {:db (p/dissoc-in db [::editor-sub/burn-pdfs-processing?])}))

(rf/reg-event-fx
 ::on-burn-ok
 (fn [{_db :db} [_ main-report-id _resp]]
   {:fx [[:dispatch
          [::editor-event/re-load-editor-data
           main-report-id
           [::burn-completed]]]]}))

(rf/reg-event-fx
 ::on-burn-failed
 (fn [{db :db} [_ err]]
   (js/console.log "Burn failed " err)
   {:db (p/dissoc-in db [::editor-sub/burn-pdfs-processing?])}))

(rf/reg-event-fx
 ::upload-fund-pdf
 (fn [{_db :db} [_ report-id main-report-id pdf-content]]
   {::ws/send {:id         :lp-report/burn-pdf
               :body       {:report-id   report-id
                            :pdf-content pdf-content}
               :on-success [::on-burn-ok main-report-id]
               :on-error   [::on-burn-failed]}}))


(rf/reg-event-fx
 ::burn-pdfs
 (fn [{db :db} [_ selected-report main-report-id feeder?]]
   (fu/timeout 100
               #(let [template-type (:lp-report/template-type selected-report)
                      pdf-doc (cond feeder?
                                    (feeder-report->doc-def db selected-report)
                                    (or (= template-type :lp-report-template.lifeline/fund)
                                        (= template-type :lp-report-template.lifeline/fund-v)
                                        (= template-type :lp-report-template.lifeline/fund-vi))
                                    (main-report->lifeline-custom-doc-def db)
                                    :else
                                    (main-report->doc-def db))]
                  (.call (aget pdf-doc "getDataUrl")
                         pdf-doc
                         (fn [outdoc]
                           (let [report-id (:db/id selected-report)]
                             (rf/dispatch [::upload-fund-pdf report-id main-report-id outdoc]))))))
   {:db (assoc-in db [::editor-sub/burn-pdfs-processing?] true)}))


(rf/reg-event-fx
 ::change-tab
 (fn [{db :db} [_ report-tab-path tab-key]]
   {:db (assoc-in db report-tab-path tab-key)}))

(rf/reg-event-db
 ::set-pdf-preview-url
 (fn [db [_ url]]
   (assoc db ::common-sub/pdf-preview-url url)))

(rf/reg-event-fx
 ::generate-pdf-preview
 (fn [{:keys [db]} [_ report feeder?]]
   (let [template-type (:lp-report/template-type report)
         pdf-doc (cond feeder?
                       (feeder-report->doc-def db report)
                       (or (= template-type :lp-report-template.lifeline/fund)
                           (= template-type :lp-report-template.lifeline/fund-v)
                           (= template-type :lp-report-template.lifeline/fund-vi))
                       (main-report->lifeline-custom-doc-def db)
                       :else
                       (main-report->doc-def db))
         getBlob (aget pdf-doc "getBlob")]
     (.call getBlob pdf-doc
            (fn [blob]
              (let [url (.createObjectURL js/URL blob)]
                (rf/dispatch [::set-pdf-preview-url url])))))
   {}))

(rf/reg-event-fx
 ::generate-holding-pdf-preview
 (fn [{:keys [db]} [_ holding-id]]
   (let [pdf-doc (holding-report->doc-def db holding-id)
         getBlob (aget pdf-doc "getBlob")]
     (.call getBlob pdf-doc
            (fn [blob]
              (let [url (.createObjectURL js/URL blob)]
                (rf/dispatch [::set-pdf-preview-url url])))))
   {}))


(rf/reg-event-fx
 ::clear-pdf-preview-url
 (fn [{:keys [db]} _]
   (let [url (::common-sub/pdf-preview-url db)]
     (when url
       (.revokeObjectURL js/URL url))
     {:db (dissoc db ::common-sub/pdf-preview-url)})))

(rf/reg-event-fx
 ::open-pdf-preview
 (fn [{:keys [db]} [_ report feeder?]]
   {:db       (assoc db ::common-sub/preview-mode? true)
    :dispatch [::generate-pdf-preview report feeder?]}))

(rf/reg-event-fx
 ::open-holding-pdf-preview
 (fn [{:keys [db]} [_ h-report-id]]
   {:db       (assoc db ::common-sub/preview-mode? true)
    :dispatch [::generate-holding-pdf-preview h-report-id]}))

(rf/reg-event-fx
 ::close-pdf-preview
 (fn [{:keys [db]} _]
   {:db       (assoc db ::common-sub/preview-mode? false)
    :dispatch [::clear-pdf-preview-url]}))
